/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";

@Directive({
	selector: "[globalictccBadge]",
	standalone: true
})
export class BadgeDirective {
	/**
	 * @Input() globalictccBadge
	 *
	 * This input property is used to conditionally add a badge to the host element.
	 * When the `enabled` parameter is set to `true`, a badge element is created and styled,
	 * then appended to the host element. The badge is styled to appear as a small green circle
	 * positioned at the top-right corner of the host element.
	 *
	 * @param enabled - A boolean value that determines whether the badge should be added.
	 */
	@Input() public set globalictccBadge(enabled: boolean) {
		if (enabled) {
			const badge = this._renderer.createElement("span");

			this._renderer.setStyle(badge, "position", "absolute");
			this._renderer.setStyle(badge, "top", "0");
			this._renderer.setStyle(badge, "right", "0");
			this._renderer.setStyle(badge, "backgroundColor", "var(--green)");
			this._renderer.setStyle(badge, "borderRadius", "100%");
			this._renderer.setStyle(badge, "padding", "5px");

			const parent = this._currentElement.nativeElement;

			this._renderer.setStyle(parent, "position", "relative");
			this._renderer.appendChild(parent, badge);
		}
	}

	constructor(
		private _currentElement: ElementRef,
		private _renderer: Renderer2
	) {}
}
